module.exports = __webpack_public_path__ + "static/media/work.eda327a3.svg";